import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export default function DatePickerMui({label = "Select Date", onChange, ...props}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker 
        label={label} 
        format="YYYY-MM-DD"
        sx={{width: "100%"}}
        onChange={(newValue) => {
          if (newValue) {
            const formatted = newValue.format("YYYY-MM-DD");
            onChange(formatted);
          }
        }}
        slotProps={{
          toolbar: { hidden: true }
        }}
      />
    </LocalizationProvider>
  );
}